//@ts-check
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { useStore } from '../../../pages/manage/store';
import { ContainerContext } from '../../../utils';
import getXrAppBuilderApps from '../actions/get-xr-app-builder-apps';

/** @param {import('@action-types/xrApp').UseXrAppBuilderAppsOptions} [options] */
const useXrAppBuilderApps = (options = {}) => {
  const { ims } = useContext(ContainerContext);
  const token = ims?.getAccessToken()?.token;
  const org = useStore((state) => state.selectedOrg?.code);
  const enabled = Boolean(token && org && (options?.enabled ?? true));

  const data = useQuery({
    queryKey: ['get-xr-app-builder-apps', token, org],
    queryFn: async ({ signal }) => {
      const response = await getXrAppBuilderApps({
        org,
        token,
        signal,
      });
      if (response.apps) {
        response.apps = response.apps.filter((app) => app?.jaeger);
      }
      return response;
    },
    ...options,
    enabled,
  });

  return data;
};

export default useXrAppBuilderApps;
